<div class="carrier-selector" (click)="$event.stopPropagation()">
  <div class="trigger" (click)="toggleOpen()">
    <div class="label">
      <span class="selected" *ngIf="selected">{{ selected.Name }}</span>
      <span class="placeholder" *ngIf="!selected">{{ placeholder }}</span>
    </div>
    <span class="chevron" aria-hidden="true"></span>
  </div>

  <div class="panel" *ngIf="open">
    <div class="search">
      <span class="icon" aria-hidden="true"></span>
      <input type="text" [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)" placeholder="Search..." />
      <button class="clear" *ngIf="searchTerm" (click)="clearSearch()" type="button" aria-label="Clear search" title="Clear search">&times;</button>
    </div>
    <ul class="list">
      <li class="item" *ngFor="let c of filteredCarriers" (click)="selectCarrier(c)">
        <div class="name">{{ c.Name }}</div>
        <div class="meta">
          <span class="carrier-key">{{ (c.ApiKey | slice:0:8) }}…</span>
        </div>
      </li>
      <li class="empty" *ngIf="filteredCarriers.length === 0">No results</li>
    </ul>
  </div>
</div>


